<template>
  <b-card no-body class="position-relative overflow-hidden py-50">


    <b-card-body  class="zindex-1 d-flex flex-column justify-content-between py-50">
      <b-row class="justify-content-center">

        <b-col cols="8">
          <div class="d-flex align-items-center pb-2">
            <small class="">{{ card.title }}</small>

          </div>
          <b-skeleton width="80px" height="30px" v-if="loading"/>
          <span :style="card.color"  class="h3" v-else>{{ card.value }}</span>
        </b-col>
        <b-col cols="4 d-flex justify-content-end pr-0">
          <b-img
              :src="require('@/assets/images/fxlegends-new-theme/'+card.chart)"
              width="50"
              rounded
              alt="Rounded image"
              class="d-inline-block m-50"
          />
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>

</template>

<script>
import {BCard, BCardBody , BButton, BRow, BCol, BImg, BSkeleton} from "bootstrap-vue";
export default {
  components: {
    BCard, BCardBody,BButton, BRow, BCol, BImg, BSkeleton
  },
  props:{
    card:{
      type:Object,
      default:()=>{}
    },
    loading: {
      type: Boolean,
      default:false
    },
  }
}
</script>
